import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MySafeHtml } from 'src/app/admin/shared/pipes/safe-html.pipe';
import { ImageDialogComponent } from 'src/app/shared/dialogs/image-dialog/image-dialog.component';
import { NuggetEvent } from 'src/app/shared/models/nugget-event.model';
import { Base64ToImagePipe } from 'src/app/shared/pipes/base64-to-image.pipe';

@Component({
  selector: 'app-weekly-nugget-summary',
  templateUrl: './weekly-nugget-summary.component.html',
  styleUrls: ['./weekly-nugget-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Base64ToImagePipe, MySafeHtml],
})
export class WeeklyNuggetSummaryComponent {
  private dialog = inject(MatDialog);

  readonly nugget = input.required<NuggetEvent>();

  openImage(src: string) {
    this.dialog.open(ImageDialogComponent, { data: { url: src, base64: true } });
  }
}
